import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { CustomerGreenClassificationModel } from "../../models/CustomerGreenClassificationModel";
import CustomerGreenClassificationService from "../../services/CustomerGreenClassificationService";
import CustomerGreenClassificationSlice from "../slices/CustomerGreenClassificationSlice";
import { RootState } from "../store";

export const Actions = CustomerGreenClassificationSlice.actions;

export const fetchCustomerGreenClassifications = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(Actions.setIsCustomerGreenClassificationsFetching(true));
    const response: CustomerGreenClassificationModel[] =
      await CustomerGreenClassificationService.getCustomerGreenClassifications();
    dispatch(Actions.setCustomerGreenClassifications(response));
    dispatch(Actions.setIsCustomerGreenClassificationsFetching(false));
  };
};
